import axios from '../utils/axios';

export default function getSingleJob(recId, jobId, params) {
    return (
        axios.get('/admin/' + recId + '/job/' + jobId, { params })
        .then(res => {
            return res.data
        })
        .catch(err => {
            return err;
        })
    )
}
